import { Navigate } from "react-router-dom";
import { isTokenValid } from "../utils/auth";

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token || !isTokenValid(token)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequireAuth;
